export const LogoType = Object.freeze({
  COMPANY: 'company', // Company logo
  APP: 'app', // App logo (Ready2Book)
})
